import {
  authStorage,
  genericStorage,
  kycStorage,
  removeCookie,
  transactionStorage,
} from '@ajaibid/utils';
import { COOKIE_KEY } from '@config/constanta';

const LOGOUTURL = process.env.LOGOUT_URL;

export default function clearSession(shouldRedirectToLogout = true) {
  removeCookie(COOKIE_KEY.refresh_token);
  removeCookie(COOKIE_KEY.access_token);
  removeCookie(COOKIE_KEY.pin_token);
  removeCookie(COOKIE_KEY.hashedHeader);
  removeCookie(COOKIE_KEY.redirect);

  genericStorage.remove('hide_influencer_banner');
  authStorage.clear();
  transactionStorage.clear();
  kycStorage.clear();

  // Only redirect to logout if explicitly requested
  if (shouldRedirectToLogout) {
    window.location.assign(LOGOUTURL);
  }
}
